(() => {
  const dialog = document.getElementById('MayaLanguageChoice');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'galerie-maya-language-choice-v1';
  let previousFocus;
  const remember = language => {
    try { localStorage.setItem(key, language); } catch (_) {}
  };
  const returnPathFor = language => {
    const path = location.pathname.replace(/^\/fr(?=\/|$)/, '') || '/';
    const localizedPath = language === 'fr' ? `/fr${path === '/' ? '' : path}` : path;
    return localizedPath + location.search + location.hash;
  };
  const close = () => dialog.close();
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('maya-language-choice-open');
    previousFocus?.focus();
  });
  dialog.querySelector('[data-language-close]').addEventListener('click', () => {
    remember(dialog.dataset.currentLanguage); close();
  });
  dialog.addEventListener('cancel', () => remember(dialog.dataset.currentLanguage));
  dialog.querySelector('form').addEventListener('submit', event => {
    const selected = event.submitter?.value;
    if (!selected) return;
    const returnTo = event.target.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = returnPathFor(selected);
    remember(selected);
    if (selected === dialog.dataset.currentLanguage) {
      event.preventDefault(); close();
    }
    // Keep the destination path in the selected language when Shopify redirects.
  });
  // Existing language selectors stay usable and count as an explicit choice.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id === 'MayaLanguageForm') return;
    const language = form.querySelector('[name="language_code"], [name="locale_code"]')?.value;
    if (language) {
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = returnPathFor(language);
      remember(language);
    }
  });
  let chosen;
  try { chosen = localStorage.getItem(key); } catch (_) {}
  if (chosen) return;
  previousFocus = document.activeElement;
  dialog.showModal();
  document.documentElement.classList.add('maya-language-choice-open');
})();
